import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, getApi } from 'services/rotasp/api';
import { ReducerAction } from 'store/modules/types';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';
import { RequestImprimirDare, Types } from './types';
import { imprimirDareSuccess, imprimirDareFailure } from './actions';
import { baixarArquivosRequest } from '../../utils/arquivos/baixarArquivos/actions';

function* imprimirDareRequest(request: ReducerAction) {
	const { token, payload }: { token?: string; payload: RequestImprimirDare } =
		request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		`dare/arquivo/${payload.numeroDare}`,
	);

	if (response.status === 201 || response.status === 200) {
		yield put(imprimirDareSuccess(response.data));
		if (response.data) {
			yield put(
				baixarArquivosRequest(token || '', {
					url: response.data.linkArquivo,
					instanceRequest: 'imprimir_dare',
				}),
			);
		}
	} else if (response.error) {
		yield put(imprimirDareFailure());
	}
}

export default all([
	takeLatest(Types.IMPRIMIR_DARE_REQUEST, imprimirDareRequest),
]);
